import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ChangePasswordPage } from '../change-password/change-password';

/**
 * Generated class for the SettingsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  getSettingsPage(page: string){
    this.navCtrl.push(page);
  }

  getChangePassword(){
    this.navCtrl.push(ChangePasswordPage)
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SettingsPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts